import { CurrencyCode } from '@/helpers/currency';
import { Locale } from '@/helpers/languages';

export const MAP_LOCALE_TO_CURRENCY: Record<Locale, CurrencyCode> = {
  [Locale.ENGLISH]: CurrencyCode.USD,
  [Locale.ENGLISH_AUSTRALIA]: CurrencyCode.AUD,
  [Locale.ENGLISH_CANADA]: CurrencyCode.CAD,
  [Locale.ENGLISH_IRELAND]: CurrencyCode.EUR,
  [Locale.ENGLISH_NEW_ZEALAND]: CurrencyCode.NZD,
  [Locale.ESTONIA]: CurrencyCode.EUR,
  [Locale.FINLAND]: CurrencyCode.EUR,
  [Locale.FRENCH_CANADA]: CurrencyCode.CAD,
  [Locale.FRENCH_SWITZERLAND]: CurrencyCode.EUR,
  [Locale.GERMAN]: CurrencyCode.EUR,
  [Locale.NORWEGIAN]: CurrencyCode.NOK,
};
